module.exports = __webpack_public_path__ + "static/media/error_sound.06837ac7.wav";